import { render, staticRenderFns } from "./AdditionalForms.vue?vue&type=template&id=517a3eb0&"
import script from "./AdditionalForms.vue?vue&type=script&lang=js&"
export * from "./AdditionalForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports